// zIndex reference. Stacking as needed for reasons
// It was initially used on asseet page.
export const zIndexes = <const>[
  undefined,
  'table-heading',
  'table-scrollbar',
  undefined,
  undefined,
  undefined,
  undefined,
  undefined,
  'scroll-to-top',
  'page-tooltip',
  'page-overlay',
  'overlay-menu',
];
